export default {
    book: 'Book {product}',
    age_limit: 'Kun over {age}',
    change_plan: "Skift plan",
    upgrade_product: 'Opgradér produkt',
    upgrade: "Opgrader",
    cancel_upgrade: "Annuller opgradering",
    choose_product: 'Vælg {product}',
    days: '{count} dag | {count} dage',
    current: "Nuværende",
    keyless_benefits: {
        label: 'Straight to car {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Fuld forsikring',
            zero_excess: 'Nul overskydende',
            phone_as_a_key: 'Telefon som nøgle',
            straight_to_car: 'Ingen ventetid',
            no_queues: 'Ingen køer',
            online_id_check: 'Online ID-kontrol',
            self_checkout: 'Selvudtjekning',
        },
    },
}
